import { useCallback, useMemo } from "react";
import { navigateTo } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { MyTripsFilter } from "@hopper-b2b/types";
import { ButtonWrap } from "@hopper-b2b/ui";
import ErrorIcon from "../../../assets/client/error.svg?react";
import styles from "./styles.module.scss";
import { PATH_FLIGHTS } from "@/utils/urlPaths";

interface NoTripResultsProps {
  category: MyTripsFilter;
}

export const NoTripResults = ({ category }: NoTripResultsProps) => {
  const { t } = useI18nContext();

  const goToFlightSearch = useCallback(() => {
    navigateTo(PATH_FLIGHTS, {});
  }, []);

  const getNoResultsMessage = useMemo(() => {
    switch (category) {
      case MyTripsFilter.UPCOMING_TRIPS:
        return t("noTrips");
      case MyTripsFilter.PAST_TRIPS:
        return t("noBookings");
      case MyTripsFilter.PRIZE_FREEZES:
        return t("noFrozenPrices");
    }
    return;
  }, [category, t]);

  return (
    <div className={styles.NoTripResults}>
      <ErrorIcon className="error-icon" />
      <h1 className="title">{t("noTripsFound")}</h1>
      {getNoResultsMessage ? (
        <h3 className="subtitle">{getNoResultsMessage}</h3>
      ) : null}
      {[MyTripsFilter.UPCOMING_TRIPS, MyTripsFilter.PAST_TRIPS].includes(
        category
      ) ? (
        <ButtonWrap onClick={goToFlightSearch} className="action">
          {t("bookAFlight")}
        </ButtonWrap>
      ) : null}
    </div>
  );
};
